import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Camera, Lock, User } from 'lucide-react';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <Camera size={48} color="#3b82f6" />
          <h1 style={styles.title}>Hikvision Snapshots</h1>
          <p style={styles.subtitle}>Panel de Control v2</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          <div style={styles.inputGroup}>
            <User size={20} color="#6b7280" style={styles.icon} />
            <input type="text" placeholder="Usuario" value={username}
              onChange={(e) => setUsername(e.target.value)} style={styles.input} required />
          </div>
          <div style={styles.inputGroup}>
            <Lock size={20} color="#6b7280" style={styles.icon} />
            <input type="password" placeholder="Contraseña" value={password}
              onChange={(e) => setPassword(e.target.value)} style={styles.input} required />
          </div>
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)', padding: '20px' },
  card: { background: 'white', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '400px',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' },
  header: { textAlign: 'center', marginBottom: '32px' },
  title: { fontSize: '24px', fontWeight: 'bold', color: '#1f2937', margin: '16px 0 8px' },
  subtitle: { color: '#6b7280', fontSize: '14px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  inputGroup: { position: 'relative', display: 'flex', alignItems: 'center' },
  icon: { position: 'absolute', left: '12px' },
  input: { width: '100%', padding: '12px 12px 12px 44px', border: '1px solid #e5e7eb',
    borderRadius: '8px', fontSize: '16px', outline: 'none' },
  button: { background: '#3b82f6', color: 'white', border: 'none', padding: '14px',
    borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  error: { background: '#fef2f2', color: '#dc2626', padding: '12px', borderRadius: '8px',
    fontSize: '14px', textAlign: 'center' },
};

export default Login;
